export default function ContactSection() {
  return (
    <section id="contact" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">投稿爆料</h2>
            <p className="mt-2 text-sm text-foreground-500">你有料，我们有平台</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 font-heading mb-1">邮件投稿</h3>
              <p className="text-xs text-foreground-500 break-all">tips@meiridagua.com</p>
            </div>
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mb-3">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 font-heading mb-1">私信投稿</h3>
              <p className="text-xs text-foreground-500">微博/公众号 私信直发</p>
            </div>
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 mb-3">
                <i className="ri-shield-check-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 font-heading mb-1">匿名爆料</h3>
              <p className="text-xs text-foreground-500">严格保护爆料人身份</p>
            </div>
          </div>
          <p className="text-center text-xs text-foreground-400 mt-5">
            我们承诺对所有投稿信息严格保密，未经核实的内容不会发布
          </p>
        </div>
      </div>
    </section>
  );
}